import PropTypes from 'prop-types';
import Carousel from '@comp/Carousel/Carousel';
import FreeCourseCard from '@comp/FreeCourseCard/FreeCourseCard';
import { toggleBookmarkItem } from '@actions/courses';
import { useDispatchToStore } from '@hooks/reduxHooks';

const FreeTopicFeed = ({
  courses,
  blockInfo,
  title,
  seeAllLink,
  href,
  dataAnalytics
}) => {
  const dispatch = useDispatchToStore();
  const handleSaveUnSave = (courseUID, isBookmarked) => {
    return dispatch(toggleBookmarkItem(courseUID, 4, isBookmarked));
  };
  const count = blockInfo.count || blockInfo.coursesCount;
  return (
    <Carousel label={title} seeAllLink={count > 4 && seeAllLink} href={href}>
      {courses.map((course, index) => {
        return (
          <FreeCourseCard
            index={index}
            key={course.uid}
            course={course}
            onClickSave={handleSaveUnSave}
            dataAnalytics={dataAnalytics}
          />
        );
      })}
    </Carousel>
  );
};

FreeTopicFeed.propTypes = {
  courses: PropTypes.arrayOf(PropTypes.any).isRequired,
  blockInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  title: PropTypes.string.isRequired,
  seeAllLink: PropTypes.string,
  href: PropTypes.string,
  dataAnalytics: PropTypes.string.isRequired
};

FreeTopicFeed.defaultProps = {
  href: '',
  seeAllLink: ''
};

export default FreeTopicFeed;
